import { Fragment, useEffect } from "react";
import { useEffectOnce } from "../../../hooks/useeffectonce";
import { useSelector, useDispatch } from "react-redux";

import { addNotification } from "../../../redux/slices/notificationsslice";
import {
  setCurrentPageIsDirty,
  setCurrentPage,
} from "../../../redux/slices/currentpageslice";
import { notificationDurationMiddle } from "../../../lib/utils";
import { useNavigate } from "react-router-dom";
import { apiErrorsHandler, getErrorMessages } from "../../../api/httpclient";
import { Page } from "../../page";
import { deepCompare } from "../../../lib/utils";
import { BLOCK_DIRTY_MESSAGE } from "../../../settings";

import "./createschedulepage.css";
import {
  setProcessing,
  disposePage,
  loadPage,
  setPanes,
  setPageValue,
  setFormValue,
  loadReportWidgets,
  showHideGoogleSheets,
  loadGoogleSheets,
  getGoogleAuth,
  loadDataset,
  getConnectionsList,
  loadGoogleSheetId,
  loadGoogleConnectors,
} from "../../../redux/slices/createschedulepageslice";
import { CreateSchedulePageBody } from "./createschedulepagebody";
import { useTranslation } from "react-i18next";

export const CreateSchedulePage = (props) => {
  const dispatch = useDispatch();
  const currentUser = useSelector((state) => state.currentUser);
  const currentTheme = useSelector((state) => state.currentTheme);
  const pageState = useSelector((state) => state.createSchedulePage);
  const navigate = useNavigate();
  const currentPageState = useSelector((state) => state.currentPage);

  let currentPageId = "createSchedulePage";
  const { t, i18n } = useTranslation();

  /*block navigation if dirty*/
  const updateDirtyState = () => {
    let isDirty = !deepCompare(
      pageState.formInitialValues,
      pageState.formValues,
    );
    let wasDirty = currentPageState.isDirty;

    if (isDirty != wasDirty) dispatch(setCurrentPageIsDirty(isDirty));
  };

  const blockNavigationIfDirty = (msg) => {
    if (currentPageState.isDirty) {
      if (window.confirm(msg ? msg : BLOCK_DIRTY_MESSAGE) == true) {
        dispatch(setCurrentPageIsDirty(false));
        return false;
      } else return true;
    } else return false;
  };
  /*block navigation if dirty*/

  /*splitter*/
  const handleOnSplitterChange = (e) => {
    dispatch(setPanes(e.newState));
  };
  /*splitter*/

  /*initial page load*/
  useEffectOnce(() => {
    dispatch(loadPage(currentUser, t)).then(
      (response) => {
        dispatch(setCurrentPage({ id: currentPageId, isDirty: false }));
      },
      (err) => {
        //hide loader
        dispatch(setProcessing({ processing: false }));

        const handleResponseReceived = (state, dispatch, navigate, payload) => {
          let errorMessages = payload?.data?.ErrorMessages;

          //notify with error
          if (!errorMessages || errorMessages.length == 0)
            dispatch(
              addNotification({
                text: t("datasets.create.loading_error"),
                type: "error",
                closable: true,
                duration: notificationDurationMiddle,
                position: "topRight",
              }),
            );
          else {
            errorMessages = getErrorMessages(errorMessages, 1);
            dispatch(
              addNotification({
                text: errorMessages[0],
                type: "error",
                closable: true,
                duration: notificationDurationMiddle,
                position: "topRight",
              }),
            );
          }

          //go home
          navigate("/", { replace: true });
        };

        const handleUnhandled = (state, dispatch, navigate, payload) => {
          dispatch(
            addNotification({
              text: t("datasets.create.unknown_error"),
              type: "error",
              closable: true,
              duration: notificationDurationMiddle,
              position: "topRight",
            }),
          );
          navigate("/", { replace: true });
        };

        //console.log(action);
        apiErrorsHandler({}, dispatch, navigate, err, "/", {
          responseReceived: handleResponseReceived,
          unhandled: handleUnhandled,
        });
      },
    );

    return () => {
      dispatch(setCurrentPage({ id: "", isDirty: false }));
      dispatch(disposePage(true));
    };
  }, []);
  /*initial load*/

  /*toolbar*/
  const handleOnNew = (e) => {
    if (blockNavigationIfDirty() == true) return;
    dispatch(loadPage(currentUser, t)).then(
      (response) => {
        dispatch(setCurrentPage({ id: currentPageId, isDirty: false }));
      },
      (err) => {
        //hide loader
        dispatch(setProcessing({ processing: false }));

        const handleResponseReceived = (state, dispatch, navigate, payload) => {
          let errorMessages = payload?.data?.ErrorMessages;

          //notify with error
          if (!errorMessages || errorMessages.length == 0)
            dispatch(
              addNotification({
                text: t("datasets.create.loading_error"),
                type: "error",
                closable: true,
                duration: notificationDurationMiddle,
                position: "topRight",
              }),
            );
          else {
            errorMessages = getErrorMessages(errorMessages, 1);
            dispatch(
              addNotification({
                text: errorMessages[0],
                type: "error",
                closable: true,
                duration: notificationDurationMiddle,
                position: "topRight",
              }),
            );
          }

          //go home
          //navigate("/", { replace: true });
        };

        const handleUnhandled = (state, dispatch, navigate, payload) => {
          dispatch(
            addNotification({
              text: t("datasets.create.unknown_error"),
              type: "error",
              closable: true,
              duration: notificationDurationMiddle,
              position: "topRight",
            }),
          );
          //navigate("/", { replace: true });
        };

        //console.log(action);
        apiErrorsHandler({}, dispatch, navigate, err, "/", {
          responseReceived: handleResponseReceived,
          unhandled: handleUnhandled,
        });
      },
    );
  };

  const handleOnClose = (e) => {
    if (blockNavigationIfDirty() == true) return;
    navigate("/schedule");
  };

  //tools visible/hidden
  const handleOnToolsToggle = (e) => {
    const isVisible = pageState.toolsVisible;

    if (isVisible)
      //hide
      dispatch(
        setPanes([
          {
            size: "0%",
            min: "%",
            max: "%",
            collapsible: false,
          },
          {
            min: "100%",
            collapsible: false,
          },
        ]),
      );
    else
      dispatch(
        setPanes([
          {
            size: "20%",
            min: "20%",
            max: "25%",
            collapsible: false,
          },
          {
            min: "70%",
            max: "80%",
            collapsible: false,
          },
        ]),
      );

    dispatch(setPageValue({ id: "toolsVisible", value: !isVisible }));
    //dispatch(redrawTiles());
  };
  /*toolbar*/

  //#region form
  // useEffect(() => { 
  //   const steps = [
  //     { label: t("reports.reports"), isValid: true },
  //     { label: t("datasets.create.general"), isValid: undefined },
  //     { label: t("alerts.recurrence"), isValid: undefined },
  //     { label: t("extras.filter"), isValid: undefined },
  //     { label: t("datasets.create.review"), isValid: undefined },
  //     { label: t("datasets.create.result"), isValid: undefined },
  //   ];
  //   dispatch(setPageValue({ id: "steps", value: steps }));
  // }, [i18n.language]);

  const handleOnChangeReport = (id, formOnChange) => {
    let report = pageState?.formValues?.Reports?.find(
      (r) => r.ReferenceKey === id,
    );
    if (!report) {
      report = pageState?.formValues?.Reports?.find((r) => r.Id === id);
    }
    const refKey = report?.ReferenceKey ?? null;
    const reportId = report?.Id ?? null;

    if (!refKey) return;
    // Update Kendo Form (CRITICAL)
    formOnChange("reportId", { value: refKey });
    formOnChange("rptId", { value: reportId });
    // Persist to Redux (AFTER)
    dispatch(setFormValue({ id: "reportId", value: refKey }));
    dispatch(setFormValue({ id: "rptId", value: reportId }));
    // Load widgets
    dispatch(loadReportWidgets(refKey, t)).then(
      (response) => {},
      (err) => {
        //hide loader
        dispatch(setProcessing({ processing: false }));

        const handleResponseReceived = (state, dispatch, navigate, payload) => {
          let errorMessages = payload?.data?.ErrorMessages;

          //notify with error
          if (!errorMessages || errorMessages.length == 0)
            dispatch(
              addNotification({
                text: t("schedule.errorwidgets"),
                type: "error",
                closable: true,
                duration: notificationDurationMiddle,
                position: "topRight",
              }),
            );
          else {
            errorMessages = getErrorMessages(errorMessages, 1);
            dispatch(
              addNotification({
                text: errorMessages[0],
                type: "error",
                closable: true,
                duration: notificationDurationMiddle,
                position: "topRight",
              }),
            );
          }

          //go home
          navigate("/", { replace: true });
        };

        const handleUnhandled = (state, dispatch, navigate, payload) => {
          dispatch(
            addNotification({
              text: t("datasets.create.unknown_error"),
              type: "error",
              closable: true,
              duration: notificationDurationMiddle,
              position: "topRight",
            }),
          );
          navigate("/", { replace: true });
        };

        //console.log(action);
        apiErrorsHandler({}, dispatch, navigate, err, "/", {
          responseReceived: handleResponseReceived,
          unhandled: handleUnhandled,
        });
      },
    );
  };

  const handleOnChangeFormValue = (name, id, formOnChange) => {
    formOnChange(name, { value: id });
    dispatch(setFormValue({ id: name, value: id }));
  };

  const handleRecurrencyOptionChange = (e) => {
    const value = e.value;
    dispatch(setFormValue({ id: "RecurrencyFrom", value }));
  };

  const loadFilterDataFromDataset = (id) => {
    dispatch(loadDataset(id, t)).then(
      (response) => {},
      (err) => {
        //hide loader
        dispatch(setProcessing({ processing: false }));

        const handleResponseReceived = (state, dispatch, navigate, payload) => {
          let errorMessages = payload?.data?.ErrorMessages;

          if (!errorMessages || errorMessages.length == 0)
            errorMessages = [t("datacorrection.unknown_error")];
          else errorMessages = getErrorMessages(errorMessages, 1);

          dispatch(
            addNotification({
              text: errorMessages[0],
              type: "error",
              closable: true,
              duration: notificationDurationMiddle,
              position: "topRight",
            }),
          );
        };

        const handleUnhandled = (state, dispatch, navigate, payload) => {
          let errorMessage = t("datacorrection.unknown_error");
          dispatch(
            addNotification({
              text: errorMessage,
              type: "error",
              closable: true,
              duration: notificationDurationMiddle,
              position: "topRight",
            }),
          );
        };

        apiErrorsHandler({}, dispatch, navigate, err, null, {
          responseReceived: handleResponseReceived,
          unhandled: handleUnhandled,
        });
      },
    );
  };

  const loadGoogleConnectorSheets = (t) => {
    dispatch(loadGoogleSheets(pageState.formValues.ConnectionId, t)).then(
      (response) => {
        dispatch(showHideGoogleSheets(true));
      },
      (err) => {
        //hide loader
        dispatch(setProcessing({ processing: false }));

        if (err.data.ErrorCodes.GoogleUnAuthorized) {
          dispatch(getGoogleAuth(t)).then(
            (response) => {},
            (err) => {
              //hide loader
              dispatch(setProcessing({ processing: false }));

              const handleResponseReceived = (
                state,
                dispatch,
                navigate,
                payload,
              ) => {
                let errorMessages = payload?.data?.ErrorMessages;

                //notify with error
                if (!errorMessages || errorMessages.length == 0)
                  dispatch(
                    addNotification({
                      text: t("datasets.create.loading_error"),
                      type: "error",
                      closable: true,
                      duration: notificationDurationMiddle,
                      position: "topRight",
                    }),
                  );
                else {
                  errorMessages = getErrorMessages(errorMessages, 1);
                  dispatch(
                    addNotification({
                      text: errorMessages[0],
                      type: "error",
                      closable: true,
                      duration: notificationDurationMiddle,
                      position: "topRight",
                    }),
                  );
                }

                //go home
                //navigate("/", { replace: true });
              };

              const handleUnhandled = (state, dispatch, navigate, payload) => {
                dispatch(
                  addNotification({
                    text: t("datasets.create.unknown_error"),
                    type: "error",
                    closable: true,
                    duration: notificationDurationMiddle,
                    position: "topRight",
                  }),
                );
                //navigate("/", { replace: true });
              };

              //console.log(action);
              apiErrorsHandler({}, dispatch, navigate, err, "/", {
                responseReceived: handleResponseReceived,
                unhandled: handleUnhandled,
              });
            },
          );
          //navigate("/", { replace: true });
        } else {
          const handleResponseReceived = (
            state,
            dispatch,
            navigate,
            payload,
          ) => {
            let errorMessages = payload?.data?.ErrorMessages;

            //notify with error
            if (!errorMessages || errorMessages.length == 0)
              dispatch(
                addNotification({
                  text: t("schedule.googlesheeterror"),
                  type: "error",
                  closable: true,
                  duration: notificationDurationMiddle,
                  position: "topRight",
                }),
              );
            else {
              errorMessages = getErrorMessages(errorMessages, 1);
              dispatch(
                addNotification({
                  text: errorMessages[0],
                  type: "error",
                  closable: true,
                  duration: notificationDurationMiddle,
                  position: "topRight",
                }),
              );
            }

            //go home
            //navigate("/", { replace: true });
          };

          const handleUnhandled = (state, dispatch, navigate, payload) => {
            dispatch(
              addNotification({
                text: t("datasets.create.unknown_error"),
                type: "error",
                closable: true,
                duration: notificationDurationMiddle,
                position: "topRight",
              }),
            );
            //navigate("/", { replace: true });
          };

          //console.log(action);
          apiErrorsHandler({}, dispatch, navigate, err, "/", {
            responseReceived: handleResponseReceived,
            unhandled: handleUnhandled,
          });
        }
      },
    );
  };

  const loadGoogleConnections = (t) => {
    dispatch(getConnectionsList(currentUser.AppUserId, t)).then(
      (response) => {},
      (err) => {
        //hide loader
        dispatch(setProcessing({ processing: false }));

        if (err.data.ErrorCodes.GoogleUnAuthorized) {
          dispatch(getGoogleAuth(t)).then(
            (response) => {},
            (err) => {
              //hide loader
              dispatch(setProcessing({ processing: false }));

              const handleResponseReceived = (
                state,
                dispatch,
                navigate,
                payload,
              ) => {
                let errorMessages = payload?.data?.ErrorMessages;

                //notify with error
                if (!errorMessages || errorMessages.length == 0)
                  dispatch(
                    addNotification({
                      text: t("datasets.create.loading_error"),
                      type: "error",
                      closable: true,
                      duration: notificationDurationMiddle,
                      position: "topRight",
                    }),
                  );
                else {
                  errorMessages = getErrorMessages(errorMessages, 1);
                  dispatch(
                    addNotification({
                      text: errorMessages[0],
                      type: "error",
                      closable: true,
                      duration: notificationDurationMiddle,
                      position: "topRight",
                    }),
                  );
                }

                //go home
                //navigate("/", { replace: true });
              };

              const handleUnhandled = (state, dispatch, navigate, payload) => {
                dispatch(
                  addNotification({
                    text: t("datasets.create.unknown_error"),
                    type: "error",
                    closable: true,
                    duration: notificationDurationMiddle,
                    position: "topRight",
                  }),
                );
                //navigate("/", { replace: true });
              };

              //console.log(action);
              apiErrorsHandler({}, dispatch, navigate, err, "/", {
                responseReceived: handleResponseReceived,
                unhandled: handleUnhandled,
              });
            },
          );
          //navigate("/", { replace: true });
        } else {
          const handleResponseReceived = (
            state,
            dispatch,
            navigate,
            payload,
          ) => {
            let errorMessages = payload?.data?.ErrorMessages;

            //notify with error
            if (!errorMessages || errorMessages.length == 0)
              dispatch(
                addNotification({
                  text: t("schedule.connectionserror"),
                  type: "error",
                  closable: true,
                  duration: notificationDurationMiddle,
                  position: "topRight",
                }),
              );
            else {
              errorMessages = getErrorMessages(errorMessages, 1);
              dispatch(
                addNotification({
                  text: errorMessages[0],
                  type: "error",
                  closable: true,
                  duration: notificationDurationMiddle,
                  position: "topRight",
                }),
              );
            }

            //go home
            //navigate("/", { replace: true });
          };

          const handleUnhandled = (state, dispatch, navigate, payload) => {
            dispatch(
              addNotification({
                text: t("datasets.create.unknown_error"),
                type: "error",
                closable: true,
                duration: notificationDurationMiddle,
                position: "topRight",
              }),
            );
            //navigate("/", { replace: true });
          };

          //console.log(action);
          apiErrorsHandler({}, dispatch, navigate, err, "/", {
            responseReceived: handleResponseReceived,
            unhandled: handleUnhandled,
          });
        }
      },
    );
  };

  const getGoogleSheetId = (sheetId, sheetName, sheetPath, connectionId, t) => {
    dispatch(
      loadGoogleSheetId(sheetId, sheetName, sheetPath, connectionId, t),
    ).then(
      (response) => {},
      (err) => {
        //hide loader
        dispatch(setProcessing({ processing: false }));

        const handleResponseReceived = (state, dispatch, navigate, payload) => {
          let errorMessages = payload?.data?.ErrorMessages;

          //notify with error
          if (!errorMessages || errorMessages.length == 0)
            dispatch(
              addNotification({
                text: t("schedule.googlesheetid"),
                type: "error",
                closable: true,
                duration: notificationDurationMiddle,
                position: "topRight",
              }),
            );
          else {
            errorMessages = getErrorMessages(errorMessages, 1);
            dispatch(
              addNotification({
                text: errorMessages[0],
                type: "error",
                closable: true,
                duration: notificationDurationMiddle,
                position: "topRight",
              }),
            );
          }

          //go home
          //navigate("/", { replace: true });
        };

        const handleUnhandled = (state, dispatch, navigate, payload) => {
          dispatch(
            addNotification({
              text: t("datasets.create.unknown_error"),
              type: "error",
              closable: true,
              duration: notificationDurationMiddle,
              position: "topRight",
            }),
          );
          //navigate("/", { replace: true });
        };

        //console.log(action);
        apiErrorsHandler({}, dispatch, navigate, err, "/", {
          responseReceived: handleResponseReceived,
          unhandled: handleUnhandled,
        });
      },
    );
  };

  //#endregion

  return (
    <Fragment>
      <Page
        id="createSchedulePage"
        className="create-schedule-page"
        title={t("schedule.schedule")}
        animation={props.animation}
      >
        <CreateSchedulePageBody
          onChangeReport={handleOnChangeReport}
          onChangeFormValue={handleOnChangeFormValue}
          onRecurrencyOptionChange={handleRecurrencyOptionChange}
          onSplitterChange={handleOnSplitterChange}
          onToolsToggle={handleOnToolsToggle}
          onNew={handleOnNew}
          onClose={handleOnClose}
          updateDirtyState={updateDirtyState}
          loadFilterDataFromDataset={loadFilterDataFromDataset}
          loadGoogleConnectorSheets={loadGoogleConnectorSheets}
          loadGoogleConnections={loadGoogleConnections}
          getGoogleSheetId={getGoogleSheetId}
        />
      </Page>
      <style>
        {`
                    /*page class*/
                    .create-schedule-page
                    {
                        background-color: transparent;
                        padding: ${currentTheme.pagePadding};
                    }

                    .create-schedule-page .k-splitbar.k-splitbar-horizontal
                    {
                        background-color: ${currentTheme.paneSeparatorBg};
                    }

                    .create-schedule-page .k-splitbar
                    {
                        width: ${currentTheme.paneSeparatorWidth};
                    }

                    /*are you sure to delete*/
                    .create-schedule-page-are-you-sure .k-widget
                    {
                      /*width of the dialog*/
                      width: 300px;
                    }    
                    
                    .create-schedule-page-are-you-sure .k-widget .k-dialog-titlebar.k-header.k-header
                    {
                        /*bg color of the header*/
                        background-color: ${currentTheme.primary};
                    }
                    `}
      </style>
    </Fragment>
  );
};
